const SESSION_KEY = "datacord_marketing_capture_ok"
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const notify = () => {
  listeners.forEach((listener) => listener())
}

export const isMarketingCaptureRuntimeEnabled = () =>
  Boolean(import.meta.env.DEV) || import.meta.env.VITE_ENABLE_MARKETING_CAPTURE === "true"

export const marketingCapturePassword = () => {
  const fromEnv = String(import.meta.env.VITE_MARKETING_CAPTURE_KEY || "").trim()
  if (fromEnv) return fromEnv
  return import.meta.env.DEV ? "datacord-capture" : ""
}

export const wantsMarketingCapture = (pathname: string, search: string) => {
  if (new URLSearchParams(search).get("capture") === "1") return true
  return pathname === "/data-mapping"
}

export const isMarketingCaptureUnlocked = () => {
  try {
    return sessionStorage.getItem(SESSION_KEY) === "1"
  } catch {
    return false
  }
}

export const unlockMarketingCapture = (password: string) => {
  const expected = marketingCapturePassword()
  if (!expected || password !== expected) return false
  try {
    sessionStorage.setItem(SESSION_KEY, "1")
  } catch {
    return false
  }
  notify()
  return true
}

export const subscribeMarketingCaptureUnlock = subscribe
